export enum Salutation {
  MR = 'MR',
  MRS = 'MRS',
  MISS = 'MISS',
  DIVERSE = 'DIVERSE',
}

export enum Gender {
  FEMALE = 'FEMALE',
  MALE = 'MALE',
  OTHER = 'OTHER',
}

export type GenderType = CustomerIntegration.Schemas.GenderType;

export const genderToSalutation = (gender: GenderType) => {
  switch (gender) {
    case Gender.FEMALE:
      return Salutation.MRS;
    case Gender.MALE:
      return Salutation.MR;
    case Gender.OTHER:
      return Salutation.DIVERSE;
    default:
      throw new Error('Gender to Salutation mapping failed.');
  }
};

export const mapSalutationToGender = (salutation?: Salutation): GenderType | '' => {
  switch (salutation) {
    case Salutation.MR:
      return Gender.MALE;
    case Salutation.MRS:
    case Salutation.MISS:
      return Gender.FEMALE;
    case Salutation.DIVERSE:
      return Gender.OTHER;
    default:
      return '';
  }
};
